import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal"]

  open() {
    this.modalTarget.showModal()
  }

  close() {
    this.modalTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.modalTarget.close()
  }
}
